package org.example.project.enginevertrieb

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import kotlinx.serialization.json.contentOrNull
import kotlinx.serialization.builtins.ListSerializer
import org.example.project.manager.LumaticaApiManager
import org.example.project.manager.LumaticaApiSettings
import org.example.project.utils.All
import org.w3c.fetch.RequestInit

internal object LinkedInVertriebsindexApi {
    private val json = Json { ignoreUnknownKeys = true }
    suspend fun load(): List<All> = request("list")
    suspend fun connection(token: String? = null): All {
        val response = window.fetch("${LumaticaApiSettings.getBaseUrl()}/api/linkedinvertriebsindex/" + if (token == null) "connection" else "connection-save",
            if (token == null) RequestInit(headers = LumaticaApiManager.auditHeaders()) else RequestInit(method = "POST", headers = LumaticaApiManager.auditHeaders("application/json"), body = json.encodeToString(All.serializer(), All(linkedinAccessToken = token)))).await()
        if (!response.ok) error("LinkedIn-Verbindung konnte nicht gespeichert werden (HTTP ${response.status}).")
        return json.decodeFromString(All.serializer(), response.text().await())
    }
    suspend fun refresh(): List<All> = request("refresh", "{}")
    suspend fun delete(ids: List<String>): List<All> {
        val result = request("delete", json.encodeToString(All.serializer(), All(ids = ids)))
        check(result.map { it.id }.toSet() == ids.toSet()) { "Löschen wurde nicht vollständig bestätigt." }
        return result
    }
    suspend fun cancel(ids: List<String>): List<All> {
        val result = request("cancel", json.encodeToString(All.serializer(), All(ids = ids)))
        check(result.map { it.id }.toSet() == ids.toSet() && result.all { it.linkedinProspectId.isNotBlank() && it.status.isNotBlank() }) {
            "Stornierung wurde nicht vollständig bestätigt. Bitte aktualisieren."
        }
        return result
    }
    private suspend fun request(action: String, body: String? = null): List<All> {
        val response = window.fetch(
            "${LumaticaApiSettings.getBaseUrl()}/api/linkedinvertriebsindex/$action",
            if (body != null) RequestInit(method = "POST", headers = LumaticaApiManager.auditHeaders("application/json"), body = body)
            else RequestInit(headers = LumaticaApiManager.auditHeaders())
        ).await()
        val raw = response.text().await()
        if (!response.ok || !raw.trimStart().startsWith("[")) {
            val message = runCatching { json.parseToJsonElement(raw).jsonObject["message"]?.jsonPrimitive?.contentOrNull }.getOrNull()
            error(message ?: "LinkedIn-Kontakte konnten nicht geladen werden (HTTP ${response.status}).")
        }
        return if (action == "list" || action == "refresh") distinctLinkedInContacts(json.decodeFromString(ListSerializer(All.serializer()), raw))
            else json.decodeFromString(ListSerializer(All.serializer()), raw)
    }
}
